import React, { Component } from "react";
import {
  Wrapper,
  Card,
  Input,
  Row,
  Icon,
  Copy,
  Button
} from "app/NativeComponents/common";
import SearchTab from "./SearchTab";
class SearchCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_filter_options: false,
      show_sort_options: false
    };
  }

  renderFilterButton() {
    if (this.state.show_filter_options) {
      return (
        <Wrapper style={{ padding: 10 }}>
          <Copy style={{ fontSize: 12 }}>Filter By: </Copy>
        </Wrapper>
      );
    }
    return (
      <Button
        onPress={() => {
          this.setState({
            show_filter_options: !this.state.show_filter_options
          });
        }}
        style={{ padding: 10 }}
      >
        <Row>
          <Copy style={{ fontSize: 12 }}>{this.props.team_tab_title}</Copy>
          <Icon
            style={{ marginLeft: 5 }}
            fa_icon={"sort"}
            size={14}
            color={this.props.colors.light_text_color}
          />
        </Row>
      </Button>
    );
  }

  renderFilterOptions() {
    if (this.state.show_filter_options) {
      return (
        <Wrapper>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.toggleTeamTab({ value: "all", title: "All" });
            }}
            style={{ padding: 10 }}
          >
            <Copy>All</Copy>
          </Button>

          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.toggleTeamTab({ value: "team_members", title: "CRM" });
            }}
            style={{ padding: 10 }}
          >
            <Copy>CRM</Copy>
          </Button>

          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.toggleTeamTab({
                value: "driving_and_dealfinders",
                title: "Street"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Street</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.toggleTeamTab({ value: "lists", title: "Lists" });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Lists</Copy>
          </Button>

          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.toggleTeamTab({
                value: "messages",
                title: "Messages"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Messages</Copy>
          </Button>
        </Wrapper>
      );
    }
  }

  render() {
    if (this.props.user.team_clearance_level > 0) {
      return (
        <Card>
          <Row>
            <Wrapper
              style={{
                width: 50,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Icon size={26} icon="search" />
            </Wrapper>
            <Input
              style={{
                borderBottomWidth: 0,
                flex: 1
              }}
              ref="search"
              name="search"
              returnKeyType={"search"}
              blurOnSubmit={true}
              autoCorrect={false}
              autoFocus={false}
              keyboardType="default"
              placeholder={"Search Team"}
              onChange={this.props.updateTeamSearch}
              value={this.props.team_search}
              type="text"
            />
          </Row>

          <Wrapper
            style={{
              backgroundColor: this.props.colors.background_color,
              borderTopWidth: 1,
              borderTopColor: this.props.colors.border_color,
              borderTopStyle: "solid",
              padding: 5
            }}
          >
            <Row
              style={{
                justifyContent: "space-between"
              }}
            >
              {this.renderFilterButton()}
            </Row>

            {this.renderFilterOptions()}
          </Wrapper>
        </Card>
      );
    }

    return <Wrapper />;
  }
}

export default SearchCard;
